import eventBus from './eventBus';

export * from './eventBus';
export default eventBus;
